import React from "react";
//#region redux
//#endregion
//#region types
import { NumberInputWithSuggestionsProps, TextInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CustomerConstants, IconDefinitionConstants, InvoiceConstants } from "utils/constants";
import { PaymentSettingsSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import {
  HorizontalFormField,
  GroupSection,
  TextInput,
  Toggle,
  NumberInputWithSuggestions,
} from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PaymentSettingsSection: React.FC<PaymentSettingsSectionProps> = ({ connect }) => {
  const autogiroProps = connect("paymentSettings.isAutogiro");

  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Payment)}
      icon={IconDefinitionConstants.WTransactions}
      navKey={CustomerConstants.SettingsNavKeys.Payment}
    >
      <HorizontalFormField<NumberInputWithSuggestionsProps>
        Component={NumberInputWithSuggestions}
        {...connect("paymentSettings.paymentTerms")}
        label={TranslationKeys.Common.PaymentTerms}
        descriptionText={TranslationKeys.Invoice.PaymentTermsDescription}
        allowNegative={false}
        suffix={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Days).toLowerCase()}
        suggestions={InvoiceConstants.PaymentTerms}
        optional
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...autogiroProps}
        label={TranslationKeys.Invoice.Autogiro}
        descriptionText={TranslationKeys.Customer.AutogiroHelpText}
      />
      {autogiroProps.value && (
        <HorizontalFormField<TextInputProps>
          Component={TextInput}
          {...connect("paymentSettings.autogiroPayerNumber")}
          label={TranslationKeys.Invoice.PayerNumber}
          descriptionText={TranslationKeys.Invoice.PayerNumberHelpText}
          maxLength={16}
          optional
        />
      )}
    </GroupSection>
  );
};

export default PaymentSettingsSection;
